import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-split',
  templateUrl: './consignment-split.component.html',
  styleUrls: ['./consignment-split.component.css']
})
export class ConsignmentSplitComponent implements OnInit {
    consignmentKeynoSplitFrom;

    public setting?: Setting;

    public itemsListSplits: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentKeynoSplitFrom = this.stateService.getStateParams()['consignment_keyno_splitfrom'];
    }

    private async loadSetting() {
        if (!!this.consignmentKeynoSplitFrom) {
            this.setting = (await this.datatask.Post(1445, { consignment_keyno_splitfrom: this.consignmentKeynoSplitFrom }))[0];
        }
    }

    private async loadSplits() {
        if (!this.setting) return;

        return this.itemsListSplits = await this.datatask.Post(1446, { consignment_keyno_splitfrom: this.setting.consignment_keyno_splitfrom });
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    public async saveChanges() {
        if (!!this.setting) {
            try {
                this.saving = true;

                const selectedItems = (this.itemsListSplits ?? []).filter((row) => row['item_is_selected'] === '1').map((row) => ({
                    item_id: row['item_id'],
                    item_is_selected: row['item_is_selected']
                }));

                const mergeObj = {
                    consignment_keyno_splitfrom: this.setting.consignment_keyno_splitfrom,
                	records: selectedItems
                }

                const response = (await this.datatask.Post(1447, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadSplits();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    consignment_keyno_splitfrom: string;
}
